import GetWorkItemByIdRequestModelBase from '../_generated/modelBases/get-work-item-by-id-request-model-base';

export default class GetWorkItemByIdRequestModel extends GetWorkItemByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
